<template>
    <v-tooltip top color="primary" open-delay="1000">
        <template v-slot:activator="{on}">

            <v-sheet v-on="on" width="200">

                <v-select
                    solo
                    placeholder="Select operation"
                    v-model="operationModel"
                    :items="availableOperations"
                    label="Operation"
                    item-text="name"
                    item-value="value"
                    hint="Operation"
                    :hide-details="true"
                    :background-color="color"
                    return-object
                ></v-select>
            </v-sheet>

        </template>

        <span>Search operation</span>

    </v-tooltip>

</template>

<script>

export default {

    props: {
        value: {
            required: false,
            type: String,
            default: null,
        },

        dataVariable: {
            required: false,
            type: Object,
            default: null,
        },
        color: {
            type: String,
            required: true,
            default: 'grey darken-2'
        },
    },

    computed: {
        availableOperations() {

            let operations = [];

            if (!this.dataVariable) return [];

            if (this.dataVariable.type === "text" ||
                this.dataVariable.type === "email" ||
                this.dataVariable.type === "keyword" ||
                this.dataVariable.type === "phone") {
                operations = [
                    {name: 'match', value: 'match'},
                    {name: 'exists', value: 'exists'},
                ];
            } else if (this.dataVariable.type === "radio" ||
                this.dataVariable.type === "checkbox" ||
                this.dataVariable.type === "locale") {
                operations = [
                    {name: 'match', value: 'terms'},
                    {name: 'exists', value: 'exists'},
                ];
            } else if (this.dataVariable.type === "date" || this.dataVariable.ranges.length > 0) {
                operations = [
                    {name: 'match age range', value: 'age'},
                    {name: 'match', value: 'match'},
                    {name: 'range', value: 'range'},
                    {name: 'greater or equal', value: 'gte'},
                    {name: 'lesser or equal', value: 'lte'},
                    {name: 'exists', value: 'exists'},
                ];
            } else {
                operations = [
                    {name: 'match', value: 'match'},
                    {name: 'range', value: 'range'},
                    {name: 'greater or equal', value: 'gte'},
                    {name: 'lesser or equal', value: 'lte'},
                    {name: 'exists', value: 'exists'},
                ];
            }
            return operations;
        },

        operationModel: {
            get() {
                if (this.availableOperations.length === 0) {
                    return null;
                }

                let found = this.availableOperations.find((operation) => {
                    return operation.value === this.value;
                });

                if (!found) {
                    found = this.availableOperations[0];
                }

                this.$emit('input', found.value);

                return found;

            },
            set(operation) {
                this.$emit('input', operation.value);
            }
        }
    }
}
</script>
